module.exports = __webpack_public_path__ + "static/media/pagi-prev-page.0a41fd61.svg";